import React from "react";
import { Modal } from "react-bootstrap";
import RichText from "src/components/rich-text";
import Olavson from "src/assets/images/olavson.svg";
import Olav from "assets/images/olavLogo.svg";
import OrangeArrow from "assets/images/arrowRight.svg";
import * as styles from "./styles.mod.scss";
import Image from "components/image";
import CloseIcon from "assets/svgs/close-btn.svg";

const RebrandingNotice = ({ rebranding, openNotice, hideModal }) => {

  if (!rebranding?.enableRebranding) return <></>;

  const StaffImg = ({ staff }) => (
    <div className={styles.teamInfo}>
      <Image image={staff?.image} alt={staff?.image?.alt} />
      <p className={styles.name}>{staff?.name}</p>
    </div>
  );

  return (
    <div className={styles.rebrandingNoticeContainer}>
      <Modal show={openNotice} onHide={hideModal} className={styles.rebrandingModal}>
        <div className={styles.logos}>
          <img src={Olav} className={styles.olavLogo} />
          <img src={OrangeArrow} className={styles.arrow}/>
          <img src={Olavson} className={styles.olavsonLogo} />
        </div>
        <div className={styles.text}>
          <RichText blocks={rebranding?.content} />
        </div>
        <div className={styles.desktopView}>
          <div className={styles.teamData}>
            {rebranding?.team?.map((data, i) =>   <StaffImg staff={data} key={i} />)}
            {rebranding?.founder?.map((data, i) =>  <StaffImg staff={data} key={i} />)}

          </div>

        </div>
        <div className={styles.mobileView}>
          <div className={styles.teamData}>
            <div className={styles.staffMobile}>
              <div className={styles.staffImages}>

                {rebranding?.team?.map((data, i) =>  <StaffImg staff={data} key={i} />)}
              </div>
              <p className={styles.rbTeamTitle}>{rebranding?.teamTitle}</p>
            </div>
            <div className={styles.founderMobile}>
              <div className={styles.founderImages}>
                {rebranding?.founder?.map((data, i) =>   <StaffImg staff={data} key={i} />)}
              </div>
              <p className={styles.rbFounderTitle}>{rebranding?.founderTitle}</p>
            </div>
          </div>
          <div className={styles.modalCloseContainer}>
            <CloseIcon className={styles.modalClose} onClick={hideModal} />
          </div>

        </div>

      </Modal>
    </div>
  );
};

export default RebrandingNotice;